import script from "./WaTemplatePreview.vue?vue&type=script&setup=true&lang=js"
export * from "./WaTemplatePreview.vue?vue&type=script&setup=true&lang=js"

import "./WaTemplatePreview.vue?vue&type=style&index=0&id=1f9bb1a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f9bb1a8"]])

export default __exports__